import type { FaireProductEntity } from "../../entity_types/product";

export const p_61f30new: FaireProductEntity = {
  token: "p_61f30new",
  type: "product",
  name: "ConGRADulations Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/f75a56628c955505cdba5f4637b6a702aa29396799bf8f17c35b94dcf72fc560/1528388438.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/718a18e3908353b1cb06d643ff7ff3ff4db08c97e0f8ac7fc4518e0024b85581/1528388438.png",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:03.548Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
